<template>
  <div
    class="ll-mark-map"
    :class="{full:isFull}"
  >
    <LlMapNavigationTool
      @zoom-in="$_zoonInClick()"
      @zoom-out="$_zoonOutClick()"
      @reset-click="$_getCenter()"
    />
    <l-map
      ref="myMap"
      class="ll-mark-map_wrap"
      :zoom="zoom"
      :center="_mapCenter"
      :options="options"
    >
      <l-tile-layer :url="url" />
      <l-feature-group>
        <l-marker
          v-for="(item,itemIndex) in mapList"
          :key="itemIndex"
          :lat-lng="item.local"
          @click="$_markClick(item,itemIndex)"
          @mouseover="$_setIngHover(itemIndex)"
          @mouseout="$_unsetIngHover()"
        >
          <l-icon
            :shadow-url="icon.shadowUrl"
            :icon-size="icon.iconSize"
            :icon-anchor="icon.iconAnchor"
            :popup-anchor="icon.popupAnchor"
            :shadow-size="icon.shadowSize"
          >
            <div
              class="map-demo_mark-dot"
              :style="{opacity: $_getMarkHoverOpactiy(itemIndex)}"
            >
              <div
                v-for="(mark,markKey) in item.content"
                :key="markKey"
              >
                <img
                  v-if="$_getMarkType(markKey) === 'image'"
                  src="https://banner2.cleanpng.com/20180423/hlq/kisspng-larva-animated-cartoon-television-show-mosquito-larva-5ade77a32b9f80.5686987515245290591787.jpg"
                  alt=""
                  style="width:30px;height:30px"
                  class="map-demo_mark-dot_image"
                >
                <div
                  v-if="$_getMarkType(markKey) === 'graph'"
                  :style="{borderRadius:graphBorderRadius,width:`${ $_getGraphSize(mark)}px`,height:`${ $_getGraphSize(mark)}px`,boxShadow:`0 0 4px 0 ${$_getGraphColor(item.risk,'boxShadow')}`,backgroundImage:`${$_getGraphColor(item.risk,'backgroundImage')}`}"
                  class="map-demo_mark-dot_graph"
                />
                <i
                  v-if="$_getMarkType(markKey) === 'icon'"
                  class="map-demo_mark-dot_icon"
                  :class="iconStyle.iconType"
                  :style="{fontSize:`${iconStyle.iconSize}rem`,color:iconStyle.color}"
                />
              </div>
            </div>
            <div
              v-if="ingMarkHover === itemIndex"
              class="map-demo_tooltip"
            >
              <div class="map-demo_mark-dot_title">
                {{ item.name }}
              </div>
              <div
                v-for="(content,contentKey) in item.content"
                :key="contentKey"
                class="map-demo_mark-dot_content"
              >
                <p class="map-demo_mark-dot_content-title">
                  {{ $_getTooltipLabelTitle(contentKey) }}
                </p>
                <p class="map-demo_mark-dot_content-text">
                  {{ content === 0 ? '-' : content }}<span v-if="content > 0">{{ $_getTooltipUnit(contentKey) }}</span>
                </p>
              </div>
            </div>
          </l-icon>
        </l-marker>
      </l-feature-group>
    </l-map>
    <div class="ll-mark-map_filter">
      <slot name="filter" />
    </div>
  </div>
</template>
<script>
import { LMap, LTileLayer, LMarker, LIcon, LFeatureGroup } from "vue2-leaflet";
export default {
  name: "LlMarkMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LFeatureGroup,
  },
  props: {
    mapList: {
      type: Array,
      default() {
        return [];
      },
    },
    graphMarkSize: {
      type: Array,
      default() {
        return [];
      },
    },
    tooltipLabel: {
      type: Array,
      default() {
        return [];
      },
    },
    iconStyle: {
      type: Object,
      default() {
        return {};
      },
    },
    graphMarkColor: {
      type: Array,
      default() {
        return [];
      },
    },
    graphBorderRadius: {
      type: String,
      default: "",
    },
    ingMarkSelect: {
      type: Number,
      default: -1,
    },
    zoom: {
      type: Number,
      default: 10,
    },
    isFull: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      map: null,
      loading: false,
      ingMarkHover: -1,
      data: [
        {
          id: 1,
          name: "夢時代購物中心",
          local: [22.595153, 120.306923],
          opacity: 1,
          type: "image",
        },
        {
          id: 2,
          name: "漢神百貨",
          local: [22.61942, 120.296386],
          opacity: 1,
          type: "image",
        },
        {
          id: 3,
          name: "漢神巨蛋",
          local: [22.669603, 120.302288],
          opacity: 1,
          type: "circle",
        },
        {
          id: 4,
          name: "大統百貨",
          local: [22.630748, 120.318033],
          opacity: 1,
          type: "image",
        },
      ],
      center: [22.612961, 120.304167],
      url: "https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png",
      options: {
        zoomControl: false,
        scrollWheelZoom: false,
        attributionControl: false,
      },
      icon: {
        type: {
          black:
            "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-black.png",
          gold: "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-gold.png",
        },
        shadowUrl:
          "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      },
    };
  },
  computed: {
    _mapCenter() {
      if (this.mapList.length === 0) return [24.7988679, 121.0071906];
      const centerXArray = this.mapList.map((item) => item.local[0]);
      const centerYArray = this.mapList.map((item) => item.local[1]);
      const centerXSum = this.$_sumDatareduce(centerXArray);
      const centerYSum = this.$_sumDatareduce(centerYArray);
      const centerX = centerXSum / this.mapList.length;
      const centerY = centerYSum / this.mapList.length;
      return [centerX, centerY];
    },
  },
  methods: {
    $_getCenter() {
      const map = this.$refs.myMap.mapObject;
      let allmap = this.mapList.map((item) => item.local);
      if (!allmap.length) return;
      map.fitBounds(allmap);
    },
    $_resetClick() {
      const map = this.$refs.myMap.mapObject;
      map.setView(this._mapCenter, this.zoom);
    },
    $_returnToMapCenter() {
      const map = this.$refs.myMap.mapObject;
      map.panTo(this._mapCenter);
    },
    $_zoonInClick() {
      const map = this.$refs.myMap.mapObject;
      map.zoomIn();
    },
    $_zoonOutClick() {
      const map = this.$refs.myMap.mapObject;
      map.zoomOut();
    },
    $_sumDatareduce(arr) {
      return arr.reduce((a, b) => a + b);
    },
    $_getGraphColor(type, colorType) {
      if (!type) return;
      let selectMark = this.graphMarkColor.find((mark) => mark.type === type);
      if (colorType === "boxShadow") {
        return selectMark.boxShadowColor;
      } else if (colorType === "backgroundImage") {
        return selectMark.backgroundImg;
      } else if (colorType === "border") {
        return selectMark.borderColor;
      }
      return "";
    },
    $_getGraphSize(value) {
      if (value === undefined || value === null) return;
      const selectSize = this.graphMarkSize.find(
        (size) => value >= size.minRange && value <= size.maxRange
      );
      return selectSize.value;
    },
    $_getMarkType(value) {
      if (!value) return;
      const selectMarkType = this.tooltipLabel.find(
        (label) => label.value === value
      );
      return selectMarkType.type;
    },
    $_getTooltipLabelTitle(value) {
      if (!value) return;
      const selectTootipLabel = this.$_getTooltipLabel(value);
      return selectTootipLabel.label;
    },
    $_getTooltipUnit(value) {
      if (!value) return;
      const selectTootipLabel = this.$_getTooltipLabel(value);
      return selectTootipLabel.unit;
    },
    $_getTooltipLabel(value) {
      if (!value) return;
      const selectLabel = this.tooltipLabel.find(
        (label) => label.value === value
      );
      return selectLabel;
    },
    $_setIngHover(index) {
      this.ingMarkHover = index;
    },
    $_unsetIngHover() {
      this.ingMarkHover = -1;
    },
    $_getMarkHoverOpactiy(index) {
      if (this.ingMarkHover > -1 || this.ingMarkSelect > -1) {
        if (this.ingMarkHover === index || this.ingMarkSelect === index) {
          return 1;
        } else {
          return 0.2;
        }
      } else {
        return 1;
      }
    },
    $_markClick(item, itemIndex) {
      this.$emit("mark-click", { id: item.id, index: itemIndex });
    },
    async $_intMap() {
      this.loading = true;
      this.$_getCenter();
      this.loading = false;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-mark-map";
</style>